"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Item = function (_a) {
    var children = _a.children, className = _a.className, bullet = _a.bullet, other = tslib_1.__rest(_a, ["children", "className", "bullet"]);
    var classes = (0, classnames_1.default)('dsc-textList__item', bullet && "is-bullet-".concat(bullet), className);
    return ((0, jsx_runtime_1.jsx)("li", tslib_1.__assign({}, other, { className: classes, children: children })));
};
exports.Item = Item;
//# sourceMappingURL=item.js.map